module.exports = __webpack_public_path__ + "media/images/icons/instagram-55168fdbe70147b4d0d23e915a8e196d.svg";